export default function HomeIcon({ variant = "outlined" }) {
  return (
    variant === "outlined" ? (
      <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.75 18V15" stroke="#8A8A8A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path
          d="M10.8203 2.81985L3.89027 8.36985C3.11027 8.98985 2.61027 10.2998 2.78027 11.2798L4.11027 19.2398C4.35027 20.6598 5.71027 21.8098 7.15027 21.8098H18.3503C19.7803 21.8098 21.1503 20.6498 21.3903 19.2398L22.7203 11.2798C22.8803 10.2998 22.3803 8.98985 21.6103 8.36985L14.6803 2.82985C13.6103 1.96985 11.8803 1.96985 10.8203 2.81985Z"
          stroke="#8A8A8A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ) : (
      <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path opacity="0.4"
              d="M21.58 8.01002L15.03 2.77002C13.75 1.75002 11.75 1.74002 10.48 2.76002L3.92996 8.01002C2.98996 8.76002 2.41996 10.26 2.61996 11.44L3.87996 18.98C4.16996 20.67 5.73996 22 7.44996 22H18.05C19.74 22 21.34 20.64 21.63 18.97L22.89 11.43C23.07 10.26 22.5 8.76002 21.58 8.01002Z"
              fill="#560BA2"/>
        <path
          d="M12.75 18.75C12.34 18.75 12 18.41 12 18V15C12 14.59 12.34 14.25 12.75 14.25C13.16 14.25 13.5 14.59 13.5 15V18C13.5 18.41 13.16 18.75 12.75 18.75Z"
          fill="#560BA2"/>
      </svg>
    )
  )
}
